import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import './styles.css';
import UserContext from 'contexts/UserContext';
import useBreakPoint from 'hooks/useBreakPoint';
import useOverlay from 'hooks/useOverlay';
import usePromoAsset from 'hooks/usePromoAsset';

function PopupWinner() {
    const { isBreakpointActive: isMobile } = useBreakPoint();
    const navigate = useNavigate();

    const { currentPromo, currentUserResults} = useContext(UserContext);
    const [open, setOpen] = useState(currentUserResults.hasPendingPrize);
    useOverlay(open);

    const { asset: winnerMobile } = usePromoAsset(currentPromo, 'winner-mobile.png');
    const { asset: winnerDesktop } = usePromoAsset(currentPromo, 'winner-desktop.png');


    const handleClick = () => {
        setOpen(false);
        navigate(`/${currentPromo.path}/premios`)
    }

    return (
        open ?
            <div className="overlay">
                <div className="popup-container">
                    <img src={isMobile ? winnerMobile : winnerDesktop} alt="banner-week" className="popup-img" />
                    <div className="popup-cta-container" onClick={handleClick}>
                        <p className="popup-cta-text">Clique aqui para ver seu prêmio</p>
                    </div>
                </div>
            </div> : <></>
    )
}

export default PopupWinner;